<template>
  <div class="bar bar-footer">
    <div class="d-flex justify-content-between">
      <div>
        <button
          class="btn btn-dark"
          :disabled="!hasPrev"
          @click="goTo(questionIndex - 1)">
          <i class="fas fa-chevron-left"></i>
          </button>
      </div>
      <div>
        <button
          class="btn btn-success"
          v-if="viewedAllQuestions && answeredAllQuestions"
          @click="confirm=true">
          Finalizar
          </button>
        <button
          class="btn btn-dark ml-2"
          :disabled="!hasNext || !hasCurrentAnswered"
          @click="goTo(questionIndex + 1)">
          Próximo <i class="fas fa-chevron-right"></i>
          </button>
      </div>
    </div>

    <div
      v-if="confirm"
      class="modal">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--<h5
                class="modal-title"
                id="exampleModalCenterTitle">
                Finalizar
                </h5>-->
            <button
              type="button"
              class="close"
              @click="confirm=false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="py-3"
              style="font-size: 1.3em; text-align: center;">
              Deseja realmente enviar suas respostas?
              </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="confirm=false">
              Ainda não
              </button>
            <button
              type="button"
              class="btn btn-success"
              @click="finish">
              Finalizar agora
              </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'QuestionsNav',
  components: {
  },
  props: {
    questionIndex: {
      type: Number
    }
  },
  data () {
    return {
      confirm: false
    }
  },
  computed: {
    questionnaire () {
      return this.$store.getters.getQuestionnaire
    },
    totalQuestions () {
      return this.questionnaire.questions.length
    },
    viewedAllQuestions () {
      return !this.questionnaire.questions.find(v => !v.viewed)
    },
    answeredAllQuestions () {
      return !this.questionnaire.questions.find(v => !this.checkAnswered(v))
    },
    hasCurrentAnswered () {
      const question = this.questionnaire.questions[this.questionIndex]
      return this.checkAnswered(question)
    },
    hasPrev () {
      return this.questionIndex > 0
    },
    hasNext () {
      return this.questionIndex < this.totalQuestions - 1
    }
  },
  created () {
  },
  methods: {
    goTo (index) {
      this.$emit('goTo', index)
    },
    finish (num = 1) {
      this.confirm = false
      this.$emit('finish')
    },
    checkAnswered (question) {
      if (question.required) {
        if (question.type === 'checkbox' || question.type === 'mostleast') {
          return Array.isArray(question.answers) && question.answers.length
        } else if (question.type === 'file') {
          return question.answer_media_id
        } else {
          return question.answer
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.modal{
  display: block;
  background: rgba(0,0,0,0.75);
}
</style>
